module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-7-b0cc127d09a2f334c1e624f3f3c45ed6.svg";